type AppConfig = {
  API_URL: string;
  API_PORT: string;
  SSO_BASE_URL: string;
};

// Runtime values come from /config.js (generated at container start from env
// vars) and are exposed on window.__APP_CONFIG__. In local `yarn start` dev
// there is no container, so we fall back to Vite build-time env (import.meta.env).
const runtime: Partial<AppConfig> =
  (window as unknown as { __APP_CONFIG__?: Partial<AppConfig> }).__APP_CONFIG__ ?? {};

export const config: AppConfig = {
  API_URL: runtime.API_URL || import.meta.env.VITE_API_URL || '',
  API_PORT: runtime.API_PORT || import.meta.env.VITE_API_PORT || '',
  SSO_BASE_URL: runtime.SSO_BASE_URL || import.meta.env.VITE_SSO_BASE_URL || '',
};

export const apiBaseUrl = config.API_PORT
  ? `${config.API_URL}:${config.API_PORT}`
  : `${config.API_URL || ''}`;
